import { Checkbox, Col, DatePicker, Form, Icon, Input, InputNumber, Row } from 'antd'
import useFetchSelect from '../../../elements/Hooks/useFetchSelect'
import CountrySelect from '../../../elements/Select/Country'
import DeliveryCollectionDisplay from '../../../components/Purchasing/Order/DeliveryCollectionDisplay'
import DangerousGoodsItem from '../../../components/Sales/Quotes/AddQuote/DangerousGoodsItem'
import ContactDetails from '../../../elements/ContactDetails'
import FormSectionTitle from '../../../elements/FormSectionTitle'
import withSort from '../../../elements/HOC/withSort'
import useDangerGoods from '../../../elements/Hooks/useDangerGoods'
import useFetchSelectUrl from '../../../elements/Hooks/useFetchSelectUrl'
import { useForceUpdate } from '../../../elements/Hooks/useForceUpdate'
import MultiCurrency from '../../../elements/MultiCurrency'
import RegisteredPartnerDetails from '../../../elements/RegisteredPartnerDetails'
import CustomSelect from '../../../elements/Select/CustomSelect'
import Taxes from '../../../elements/Taxes'
import { get, isEmpty, merge } from 'lodash'
import { defaultFormItemLayout, fullWidthFormItemLayout, rules, threeFormItemLayout } from '../../../modules/FormItems'
import { arrVal, dateVal, findCascadersParents, strVal } from '../../../modules/Utils'
import moment from 'moment'
import React, { useEffect, useState } from 'react'

import { compose } from 'recompose'
import withSelectFetch from '../../../elements/Select/withSelectFetch'
import withSpinning from '../../../elements/HOC/withSpinning'

const { TextArea } = Input

function ReadyToOrderFreightForm(props) {
  // const { order, selectionRawData: selectionData, isNew, centers } = props
  const { order, selectionData, isNew, centers } = props
  const { getFieldDecorator, getFieldValue, setFieldsValue, resetFields } = props.form

  const [goods, setGoods] = useDangerGoods(
    arrVal(order, 'dangerousGoods').length,
    [order && order._rev],
    !isEmpty(order && order._rev)
  )

  let allDangerousGoods = []
  selectionData &&
    selectionData.forEach((cargo) => {
      cargo.package.forEach(
        (p = []) =>
          p && Array.isArray(p.dangerousGoods) && get(p, 'dangerousGoods', []).forEach((d) => allDangerousGoods.push(d))
      )
    })

  let dangerousGoods =
    allDangerousGoods && [...new Set(allDangerousGoods.map((d) => JSON.stringify(d)))].map((d) => JSON.parse(d))

  const isSameDo =
    selectionData.length === 1
      ? true
      : selectionData.every((cargo) =>
          cargo.package.every((pack) => {
            return get(pack, 'deliveryOrder._id') === get(selectionData, '[0].package[0].deliveryOrder._id')
          })
        )

  const packageObj = isSameDo ? get(selectionData, '[0]') : {}

  const typeValue = getFieldValue('valueType')

  const vendorId = (getFieldValue('vendor._id') || '').replace('members/', '')

  const [VendorQuoteSelect] = useFetchSelectUrl(
    {
      name: 'vendorQuotes',
      url: `vendorQuotes/?owner=${vendorId}&type=Logistics&select=*`,
    },
    [getFieldValue('nominatedVendor'), vendorId]
  )

  const deliveryOrder = get(packageObj, 'package[0].deliveryOrder')

  const shipper = {
    company: get(deliveryOrder, 'company'),
    address: get(deliveryOrder, 'company.address'),
    notify: get(deliveryOrder, 'companyRep'),
    email: get(deliveryOrder, 'companyRep.email'),
    tel: get(deliveryOrder, 'companyRep.phone'),
  }
  const importer = {
    company: get(deliveryOrder, 'client.member'),
    address: get(deliveryOrder, 'client.address'),
    notify: get(deliveryOrder, 'clientRep'),
    email: get(deliveryOrder, 'clientRep.email'),
    tel: get(deliveryOrder, 'clientRep.phone'),
  }
  const consignee = {
    company: get(deliveryOrder, 'client.member'),
    address: get(deliveryOrder, 'client.address'),
    notify: get(deliveryOrder, 'clientRep'),
    email: get(deliveryOrder, 'clientRep.email'),
    tel: get(deliveryOrder, 'clientRep.phone'),
  }

  const notify = get(packageObj, 'package[0].to.notify')

  const [vendorQuote, setVendorQuote] = useState({})
  const forceUpdate = useForceUpdate()
  useEffect(() => {
    console.log(
      get(order, 'tax.percentage'),
      get(vendorQuote, 'tax.percentage'),
      get(order, 'tax.type'),
      get(vendorQuote, 'tax.type')
    )

    setFieldsValue({
      vendor: get(order, 'vendor') || get(vendorQuote, 'vendor'),
      vendorRep: get(order, 'vendorRep') || get(vendorQuote, 'vendorRep'),
      company: get(order, 'company') || get(vendorQuote, 'company'),
      companyRep: get(order, 'companyRep') || get(vendorQuote, 'companyRep'),
      contract: get(order, 'contract') || get(vendorQuote, 'contract'),
      'freight.bookingType': get(order, 'freight.bookingType') || get(vendorQuote, 'freight.bookingType'),
      'freight.carriageType': get(order, 'freight.carriageType') || get(vendorQuote, 'freight.carriageType'),
      taxType: get(order, 'taxType') || get(vendorQuote, 'taxType'),
      max: get(order, 'subTotal.net') || get(vendorQuote, 'subTotal.net'),
      currency: get(order, 'currency') || get(vendorQuote, 'currency'),
    })

    order.tax = get(order, 'tax') || get(vendorQuote, 'tax')
    forceUpdate()
  }, [vendorQuote])

  let center = findCascadersParents(centers, get(deliveryOrder, 'center._id'))
  center && center.shift()

  const deliveryCountry = getFieldValue('delivery.country') || get(order, 'delivery.country', '')

  const { SelectData: DeliveryLocationSelect } = useFetchSelect({
    url: `location/${deliveryCountry}`,
    dependencyArray: [deliveryCountry],
    dontFetch: isEmpty(deliveryCountry),
    mapFunction: (i) => ({
      ...i,
      display: `[${i.locode}] ${i.location}`,
    }),
  })

  console.log(get(order, 'delivery.country'), order)

  return (
    <Form>
      <Row>
        <RegisteredPartnerDetails
          doc={{
            company: get(deliveryOrder, 'company'),
            companyRep: get(deliveryOrder, 'companyRep'),
            centers: Array.isArray(get(deliveryOrder, 'center')) ? get(deliveryOrder, 'center') : center,
            vendor: { _id: get(deliveryOrder, 'contract.supplier.owner') },
            vendorRep: get(deliveryOrder, 'contract.supplierRep'),
            contract: get(deliveryOrder, 'contract'),
            ...order,
          }}
          {...{
            getFieldDecorator,
            getFieldValue,
            setFieldsValue,
            type: 'purchase',
            title: 'FREIGHT FORWARDER DETAILS',
            showProfit: true,
            accountType: 'logistics',
          }}
        />
        <FormSectionTitle title={'FREIGHT DOCUMENT MGMT'} />
        <Row>
          <Col span={24}>
            <Form.Item {...fullWidthFormItemLayout} label={'Summarise PL'}>
              {getFieldDecorator('isService', {
                initialValue: get(order, 'isPkgConsolidated'),
                valuePropName: 'checked',
              })(<Checkbox />)}
              <span>
                <b> Tick to consolidate packages per cargo </b>
              </span>
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label={'Delivery Country'}>
              {getFieldDecorator('delivery.country', {
                initialValue: get(order, 'delivery.country'),
                rules: rules.select,
              })(<CountrySelect valueAtr={'value'} keyAtr={'value'} placeholder={'Location'} />)}
            </Form.Item>
          </Col>
          <Col span={12} />

          {getFieldValue('delivery.country') && (
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label="Location">
                {getFieldDecorator('delivery.location', {
                  initialValue: get(order, 'delivery.location'),
                  rules: rules.select,
                })(<DeliveryLocationSelect keyAtr={'locode'} valueAtr={'display'} />)}
              </Form.Item>
            </Col>
          )}
        </Row>

        <FormSectionTitle title={'FREIGHT ORDER DETAILS'} />
        <Row>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label={'Vendor Quote'}>
              {getFieldDecorator('vendorQuote._id', {
                initialValue: get(order, 'vendorQuote._id'),
              })(
                <VendorQuoteSelect
                  keyAtr={'_id'}
                  valueAtr={'title'}
                  placeholder="Select a Vendor Quote"
                  setSelected={setVendorQuote}
                  style={{ width: '100%' }}
                />
              )}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Delivery Terms">
              {getFieldDecorator('freight.terms', {
                initialValue: get(order, 'freight.terms') || 'INCOTERMS 2010',
                rules: rules.select,
              })(<DeliveryTerms />)}
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Booking Type">
              {getFieldDecorator('freight.bookingType', {
                initialValue: get(order, 'freight.bookingType'),
                rules: rules.select,
              })(<BookingType />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Carriage Type">
              {getFieldDecorator('freight.carriageType', {
                initialValue: strVal(order, 'freight.carriageType'),
                rules: rules.select,
              })(<CarriageType />)}
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label={'Title'}>
              {getFieldDecorator('title', {
                initialValue: get(order, 'title') || get(packageObj, 'title'),
                rules: rules.input,
              })(<Input placeholder={'Title'} />)}
              {/*<IconText
                text={
                  showDesc !== true
                    ? 'Optionally Add Freight Summary Description'
                    : 'Remove Freight Summary Description'
                }
                type={showDesc !== true ? 'plus-circle' : 'minus-circle'}
                onClick={() => setShowDesc(!showDesc)}
              />*/}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label={'Insurance Policy'}>
              {getFieldDecorator('insurance.policy', {
                initialValue: get(order, 'insurance.policy') || get(packageObj, 'insurance.policy'),
                //rules: rules.input,
              })(<Input placeholder={'Insurance Policy Number'} />)}
            </Form.Item>
          </Col>
        </Row>
        {/*{showDesc === true && (*/}
        <Row>
          <Col span={24}>
            <Form.Item {...fullWidthFormItemLayout} label={'Goods Description'}>
              {getFieldDecorator('description', {
                initialValue: get(order, 'description'),
                rules: rules.input,
              })(<TextArea placeholder={'Brief Description of Goods being freighted'} />)}
            </Form.Item>
          </Col>
        </Row>
        {/* )}*/}
        <Row>
          <Col span={8}>
            <Form.Item {...threeFormItemLayout} label="Order Date">
              {getFieldDecorator('date', {
                initialValue: dateVal(order, 'date') || moment(),
                rules: rules.date,
              })(<DatePicker style={{ width: '100%' }} />)}
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item {...threeFormItemLayout} label="Order Validity End">
              {getFieldDecorator('validityEnd', {
                initialValue: dateVal(order, 'validityEnd') || moment(getFieldValue('date')).add(1, 'm'),
                rules: rules.date,
              })(<DatePicker style={{ width: '100%' }} />)}
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item {...threeFormItemLayout} label="Payment Terms">
              {getFieldDecorator('paymentTerm', {
                initialValue: get(order, 'paymentTerm') || 'Account',
              })(<PaymentTermValue />)}
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <MultiCurrency
            doc={order}
            {...{
              getFieldDecorator,
              getFieldValue,
              setFieldsValue,
              type: 'purchase',
            }}
          />

          <Col span={8}>
            <Form.Item {...threeFormItemLayout} label="Value Type">
              {getFieldDecorator('valueType', {
                initialValue: get(order, 'valueType') || 'estimated',
              })(<TypeValue style={{ width: '100%' }} />)}
            </Form.Item>
          </Col>
          {typeValue !== 'fixed&firm' && typeValue && !isNew && (
            <Col span={8}>
              <Form.Item {...threeFormItemLayout} label="Maximum Amount">
                {getFieldDecorator('max', {
                  initialValue: get(order, 'max'),
                  rules: rules.input,
                })(<InputNumber style={{ width: '100%' }} />)}
              </Form.Item>
            </Col>
          )}
        </Row>
        <Row>
          <Taxes
            doc={order}
            {...{
              getFieldDecorator,
              getFieldValue,
              setFieldsValue,
              resetFields,
              type: 'freight',
              hideRate: true,
            }}
          />
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item {...fullWidthFormItemLayout} label="Shipping Instruction">
              {getFieldDecorator('condition', {
                initialValue: get(order, 'condition') || get(packageObj, 'package[0].to.shippingInst'),
              })(<TextArea rows={7} />)}
            </Form.Item>
          </Col>
        </Row>

        <ContactDetails
          {...{
            getFieldDecorator,
            getFieldValue,
            setFieldsValue,
            title: 'Shipper Details',
            doc: merge({ freight: { shipper } }, order),
            prefix: 'freight.shipper',
          }}
        />

        <ContactDetails
          {...{
            getFieldDecorator,
            getFieldValue,
            setFieldsValue,
            title: 'Buyer / Importer Details',
            doc: merge({ freight: { importer } }, order),
            prefix: 'freight.importer',
          }}
        />

        <ContactDetails
          {...{
            getFieldDecorator,
            getFieldValue,
            setFieldsValue,
            title: 'Consignee Details',
            doc: merge({ freight: { consignee } }, order),
            prefix: 'freight.consignee',
          }}
        />

        <ContactDetails
          {...{
            getFieldDecorator,
            getFieldValue,
            setFieldsValue,
            title: 'Notify Rep',
            doc: merge({ freight: { notify } }, order),
            prefix: 'freight.notify',
          }}
        />
      </Row>

      <Row>
        <Row>
          <h3>
            <FormSectionTitle title={'DANGEROUS GOODS'} />
            <Icon
              style={{ cursor: 'pointer', fontSize: 18, marginLeft: 10 }}
              type="plus-circle"
              theme="filled"
              onClick={() => setGoods((prvG) => prvG + 1)}
            />
            {goods > 1 && (
              <Icon
                style={{ cursor: 'pointer', fontSize: 18, marginLeft: 10 }}
                type="minus-circle"
                theme="filled"
                onClick={() => setGoods((prvG) => prvG - 1)}
              />
            )}
          </h3>
          {Array.apply(null, { length: goods })
            .map(Number.call, Number)
            .map((item) => (
              <DangerousGoodsItem
                item={item}
                quote={{ dangerousGoods, ...order }}
                resetFields={resetFields}
                getFieldValue={getFieldValue}
                attrPrefix={''}
                getFieldDecorator={getFieldDecorator}
              />
            ))}
        </Row>
      </Row>
      <Row>{isNew && <DeliveryCollectionDisplay doc={order} />}</Row>
    </Form>
  )
}

const BookingType = compose(
  withSelectFetch({
    dropdown: 'purchase',
    name: 'bookingType',
  }),
  withSpinning,
  withSort
)(CustomSelect)

const CarriageType = compose(
  withSelectFetch({
    dropdown: 'purchase',
    name: 'carriageType',
  }),
  withSpinning,
  withSort
)(CustomSelect)

const DeliveryTerms = compose(
  withSelectFetch({
    dropdown: 'purchase',
    name: 'incoTerms',
  }),
  withSpinning,
  withSort
)(CustomSelect)

const PaymentTermValue = compose(
  withSelectFetch({
    dropdown: 'purchase',
    name: 'paymentTerms',
  }),
  withSpinning,
  withSort
)(CustomSelect)

const TypeValue = compose(
  withSelectFetch({
    dropdown: 'purchase',
    name: 'valueType',
  }),
  withSpinning,
  withSort
)(CustomSelect)

ReadyToOrderFreightForm.defaultProps = {
  order: {},
  selectionData: [],
}

export default Form.create()(ReadyToOrderFreightForm)
